"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
function SiteAlert({ children, className, emergency = false, heading, icon = true, onClose, slim = false }) {
    return ((0, jsx_runtime_1.jsx)("section", { className: (0, uswds_react_utils_1.createClassString)('usa-site-alert', emergency ? 'usa-site-alert--emergency' : 'usa-site-alert--info', !heading && !slim && 'usa-site-alert--no-heading', !icon && 'usa-site-alert--no-icon', slim && 'usa-site-alert--slim', className), "aria-label": "Site alert", children: (0, jsx_runtime_1.jsx)(__1.Alert, { heading: heading, onClose: onClose, children: children }) }));
}
exports.default = SiteAlert;
